/** Lazy DOMPurify loader — browser only (matches sanitized-html plugin). */
export const getDOMPurify = async () => {
  const mod = await import('dompurify')
  return mod.default
}
